import type { ProspectStatus } from "@/lib/types";
import { cn } from "@/lib/cn";

const styles: Record<ProspectStatus, string> = {
  NEW:           "bg-zinc-100 text-zinc-800",
  CONTACTED:     "bg-blue-50 text-blue-700",
  ENGAGED:       "bg-indigo-50 text-indigo-700",
  QUALIFIED:     "bg-violet-50 text-violet-700",
  NEGOTIATING:   "bg-amber-50 text-amber-700",
  CLOSING:       "bg-orange-50 text-orange-700",
  WON:           "bg-emerald-50 text-emerald-700",
  LOST:          "bg-rose-50 text-rose-700",
  UNRESPONSIVE:  "bg-zinc-100 text-zinc-600",
  RE_ENGAGEMENT: "bg-sky-50 text-sky-700",
  ARCHIVED:      "bg-zinc-100 text-zinc-500",
};

export default function StatusBadge({ status }: { status: ProspectStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        styles[status],
      )}
    >
      {status}
    </span>
  );
}
